<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add Transport Order</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" :disabled="data.transport_order_details.length > 0 ? false : true">Save</vs-button>
                </div>
                <vs-tabs>
                    <vs-tab label="Details">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        TRO ID*
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" disabled/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Reference *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.transport_reference" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Req. Del. Date *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="data.transport_order.req_del_date" :disabled="withRef"/>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Outbound Reference
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.outbound_reference" :disabled="true" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Order Type *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="orderTypeOptions" v-model="data.transport_order.order_type" label="order_type" :clearable="false" :disabled="withRef"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Client ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="clientOptions" v-model="data.transport_order.client" label="name" @input="clientChange()" :clearable="false" :disabled="withRef"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="customerOptions" v-model="data.transport_order.origin" label="name" @input="setOrigin()" :clearable="false" :disabled="withRef"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Address
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.origin_1" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.origin_2" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin Area *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.origin_area" label="village" @search="searchArea" :clearable="false"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Origin Sub Area
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.origin_subarea" label="village" @search="searchArea" :clearable="true"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="customerOptions" v-model="data.transport_order.destination" label="name" @input="setDestination()" :clearable="false" :disabled="withRef"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Address
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.destination_1" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.destination_2" :disabled="true"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination Area *
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.destination_area" label="village" @search="searchArea" :clearable="false"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Destination Sub Area
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="areaOptions" v-model="data.transport_order.destination_subarea" label="village" @search="searchArea" :clearable="true"></v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Transport">
                        <div class="vx-row mt-6">
                            <div class="vx-col md:w-1/2 w-full">

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Transporter ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="transporterOption" v-model="data.transport_order.transporter_id" label="transporter_code" :reduce="transporter_id => transporter_id.id" @search="searchTransporter" :disabled="withRef"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Service Type ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="serviceTypeOption" v-model="data.transport_order.service_type_id" label="service_type" :reduce="service_type_id => service_type_id.id" :disabled="withRef"></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Tracking Reference
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.tracking_reference" :disabled="true"/>
                                    </div>
                                </div>
                              
                            </div>
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                       Payment Type
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="paymentTypeOption" v-model="data.transport_order.payment_type_id" label="payment_type" :reduce="payment_type_id => payment_type_id.id" ></v-select>
                                    </div>
                                </div>
                               <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Currency
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select :options="currencyOption" v-model="data.transport_order.currency_id" label="currency_code" :reduce="currency_id => currency_id.id"></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Order Value
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.transport_order.order_value"/>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Internal Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.transport_order.internal_notes" label="Internal Notes" height="200" />
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="External Notes">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.transport_order.external_notes" label="External Notes" height="200" />
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Attachment">
                    </vs-tab>
                </vs-tabs>
            </vs-card>
            <vs-card class="p-4">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <h4>Transport Order Details</h4>
                    <vs-button @click="addItem()" class="btn mb-4 md:mb-0 mr-1" :disabled="data.transport_order.client != null ? false : true ">Add</vs-button>
                </div>
                <div style="overflow-y: auto;">
                    <table cellspacing="5">
                        <thead>
                            <tr>
                                <th style="width: 1%">Line ID</th>
                                <th style="width: 15%">Warehouse</th>
                                <th style="width: 15%">Product</th>
                                <th style="width: 10%">Description</th>
                                <th style="width: 5%">Pack ID</th>
                                <th style="width: 5%">Batch</th>
                                <th style="width: 10%">Exp. Date</th>
                                <th style="width: 5%">Qty</th>
                                <th style="width: 5%">UoM</th>
                                <th style="width: 10%">Stock Type</th>
                                <th style="width: 5%">Base Qty</th>
                                <th style="width: 5%">Base UoM</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, index) in data.transport_order_details" :key="index">
                                <td>
                                    <vs-input class="w-full" v-model="detail.line_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.warehouse_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="withRef"
                                    >
                                        <vs-select-item v-for="(item, index) in warehouseOptions" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.product_id"
                                        width="100%"
                                        autocomplete
                                        @change="getProduct(detail)"
                                        :disabled="withRef"
                                    >
                                        <vs-select-item v-for="(item, index) in productOptions" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.description" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.pack_id" :disabled="detail.product_id == null || withRef"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.batch" :disabled="detail.product_id == null || withRef"/>
                                </td>
                                <td>
                                    <flat-pickr class="w-full" v-model="detail.expired_date" :disabled="detail.product_id == null || withRef"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.qty" :danger="detail.qtyError" @input="convertQty(detail); validateQty(detail)" :disabled="detail.product_id ? false : true"/>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.uom_id"
                                        width="100%"
                                        autocomplete
                                        @change="convertQty(detail)"
                                        @input="uomChange(detail)"
                                        :disabled="detail.qty > 0 || withRef"
                                    >
                                        <vs-select-item v-for="(item, index) in detail.uomOptions" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.stock_type_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="detail.product_id ? false : true"
                                    >
                                        <vs-select-item v-for="(item, index) in stockTypeOptions" :key="index" :value="item.value" :text="item.text" />
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.base_qty" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-select
                                        class="selectExample"
                                        v-model="detail.base_uom_id"
                                        width="100%"
                                        autocomplete
                                        :disabled="true"
                                    >
                                        <vs-select-item v-for="(item, index) in detail.defaultUom" :key="index" :value="item.value" :text="item.text"/>
                                    </vs-select>
                                </td>
                                <td>
                                    <vs-button color="danger" class="btn mb-4 md:mb-0 mr-1" @click="removeDetail(index)">Delete</vs-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components:{
            vSelect,
            flatPickr,
        },
        data(){
            return {
                isLoading: false,
                detailsCount: 0,
                data: {
                    transport_order: {
                        transport_reference: '',
                        req_del_date: null,
                        order_type: this.$store.state.user.userconfig.outbound_type,
                        client: this.$store.state.user.userconfig.clients,
                        outbound_reference: null,
                        origin: this.$store.state.user.userconfig.origin,
                        origin_1: this.$store.state.user.userconfig.origin.address_1,
                        origin_2: this.$store.state.user.userconfig.origin.address_2,
                        origin_area:this.$store.state.user.userconfig.warehouse_area,
                        origin_subarea:null,
                        destination: this.$store.state.user.userconfig.destination,
                        destination_1: this.$store.state.user.userconfig.destination.address_1,
                        destination_2: this.$store.state.user.userconfig.destination.address_2,
                        destination_area:null,
                        destination_subarea:null,
                        order_type_id: null,
                        client_id: null,
                        origin_id: null,
                        destination_id: null,

                        //transport
                        transporter_id:null,
                        service_type_id:null,
                        tracking_reference:'',
                        payment_type_id:null,
                        currency_id:null,
                        order_value:0,
                        internal_notes:'',
                        external_notes:'',
                    },
                    transport_order_details: [],
                },
                withRef:false,
                clientTypeOptions: [],
                areaOptions: [],
                maxRetry: 10,
                orderTypeOptions: [],
                clientOptions: [],
                customerOptions: [],
                selectedId: null,
                productOptions: [],
                warehouseOptions: [],
                stockTypeOptions: [],

                // transport
                serviceTypeOption:[],
                transporterOption:[],
                currencyOption:[],
                paymentTypeOption:[],

            }
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData(api) {
                return this.$http.get(api)
            },
            searchArea(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        village: search
                    }
                    this.$http.post('master/areas', data)
                    .then(res => {
                        this.areaOptions = res.data.data
                        loading(false)
                    })
                    .catch((error) => {
                        loading(false)
                        console.log(error)
                        // this.searchArea(search, loading)
                    })
                }
            },
            searchTransporter(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/transporters/filter/search', data)
                    .then(res => {
                        this.clientOption = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchTransporter(search, loading)
                    })
                }
            },
            submitForm() {
                const warehouseIds = [...new Set(this.data.transport_order_details.map(item => item.warehouse_id))]

                // if(!this.data.transport_order.transport_reference || !this.data.transport_order.order_type || !this.data.transport_order.origin || !this.data.transport_order.destination || !this.data.transport_order.req_del_date || !this.data.transport_order.client) {
                //     this.$vs.notify({
                //         color: 'danger',
                //         title: 'Field Required',
                //         iconPack: 'feather',
                //         icon:'icon-x',
                //         text: 'Please fill mandatory transport header field'
                //     })
                //     return false
                // }

                if(warehouseIds.length != 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Product Required',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Please insert at least 1 Product'
                    })
                    return false
                }

                for(let detail of this.data.transport_order_details){
                    if(!detail.warehouse_id || !detail.product_id || !detail.qty || detail.qty <= 0 || !detail.uom_id || !detail.stock_type_id) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Error saving, check line ' + detail.line_id
                        })
                        return false
                    }
                }

                this.isLoading = true
                this.data.transport_order.client_id = this.data.transport_order.client.id
                this.data.transport_order.order_type_id = this.data.transport_order.order_type.id
                this.data.transport_order.origin_id = this.data.transport_order.origin.id
                this.data.transport_order.origin_area_id = this.data.transport_order.origin_area.id
                this.data.transport_order.destination_id = this.data.transport_order.destination.id
                this.data.transport_order.destination_area_id = this.data.transport_order.destination_area.id
                if(this.data.transport_order.origin_subarea){
                    this.data.transport_order.origin_subarea_id = this.data.transport_order.origin_subarea.id
                }
                if(this.data.transport_order.destination_subarea){
                    this.data.transport_order.destination_subarea_id = this.data.transport_order.destination_subarea.id
                }

                if(this.data.transport_order.outbound_reference != null){
                    this.data.transport_order.outbound_reference = this.data.transport_order.outbound_reference
                }

                let data = {
                    transport_order : JSON.stringify(this.data.transport_order),
                    transport_order_details : JSON.stringify(this.data.transport_order_details),
                };

                this.data.transport_order_details = this.combineLine()
                this.$http.post('transport/transportorder/store', data)
                .then(res => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Saved successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Transport Order added'
                    })
                    this.$router.push({ name: 'transportorder'})
                })
                .catch(error => {
                    if(error.response.data) {
                        error.response.data.map(message => {
                            this.$vs.notify({
                                color: 'danger',
                                iconPack: 'feather',
                                icon:'icon-x',
                                text: message
                            })
                        })
                    }
                    else {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Something went wrong'
                        })
                    }
                })
                .then(() => {
                    this.isLoading = false
                })
            },
            back() {
                this.$vs.dialog({
                    color: 'warning',
                    title: 'Leave Page',
                    text: 'Changes you made may not be saved',
                    acceptText: 'Leave Page',
                    accept: () => this.$router.go(-1),
                })
            },
            fetchAllData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                this.$http.all([
                    this.$http.post('master/clients'), 
                    this.$http.post('master/ordertypes'), 
                    this.$http.post('master/customers'), 
                    this.$http.post('master/areas'),
                    this.$http.post('master/transporters'), 
                    this.$http.post('master/currency'), 
                    this.$http.post('master/servicetypes'), 
                    this.$http.get('master/paymenttypes'), 
                    ])
                .then(this.$http.spread((clients, ordertypes, customers, areas, transporters, currency, servicetypes, paymenttypes) => {
                    this.clientOptions = clients.data.data
                    this.orderTypeOptions = ordertypes.data.data
                    this.customerOptions = customers.data.data
                    this.areaOptions = areas.data.data
                    this.transporterOption = transporters.data.data
                    this.currencyOption = currency.data
                    this.serviceTypeOption = servicetypes.data.data
                    this.paymentTypeOption = paymenttypes.data

                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                }))
                .catch(() => {
                    if(this.maxRetry < 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.fetchAllData()
                                this.maxRetry = 10
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        })
                        return;
                    }
                    this.fetchAllData()
                })
            },
            removeDetail(index){
                this.data.transport_order_details.splice(index, 1)
                this.assignLineId()
            },
            addItem() {
                // if(this.$route.params.withReference){

                // }else{

                // }
                if(this.productOptions.length == 0 || this.warehouseOptions.length == 0 || this.stockTypeOptions.length == 0) {
                    this.isLoading = true
                    this.productOptions = []
                    
                    this.$http.all([this.$http.post('master/warehouses'), this.$http.post('master/product/showbyclient',{ client_code: this.data.transport_order.client.client_code }), this.$http.post('master/stocktypes')])
                    .then(this.$http.spread((warehouses, products, stocktypes) => {
                        if(this.warehouseOptions.length == 0){
                            warehouses.data.data.map(item => {
                                this.warehouseOptions.push({
                                    value: item.id,
                                    text: item.name
                                })
                            })
                        }
    
                        if(this.productOptions.length == 0){
                            products.data.data.map(item => {
                                this.productOptions.push({
                                    value: item.id,
                                    text: item.product_code,
                                })
                            })
                        }
    
                        if(this.stockTypeOptions.length == 0){
                            stocktypes.data.data.map(item => {
                                this.stockTypeOptions.push({
                                    value: item.id,
                                    text: item.name,
                                })
                            })
                        }
    
                        this.detailsCount++
                        this.data.transport_order_details.push({
                            line_id: this.detailsCount,
                            warehouse_id: this.$store.state.user.userconfig.warehouse_id,
                            product_id: null,
                            description: '',
                            pack_id: '',
                            batch: '',
                            expired_date: null,
                            qty: '',
                            uom_id: null,
                            stock_type_id: this.$store.state.user.userconfig.stock_type_id,
                            committed_qty: 0,
                            base_qty: '',
                            base_uom_id: null,
                            uomOptions: [],
                            defaultUom: [],
                            qtyError: false,
                            denominator: 0,
                            numerator: 0,
                        })
    
                        setTimeout(() => {
                            this.isLoading = false
                        }, 500)
    
                        this.assignLineId()
                    }))
                    // .catch(() => {
                    //     if(this.maxRetry < 0){
                    //         this.isLoading = false
                    //         this.$vs.dialog({
                    //             type: 'confirm',
                    //             color: 'danger',
                    //             title: 'Server Error',
                    //             text: 'Try again?',
                    //             accept: () => {
                    //                 this.addItem()
                    //                 this.maxRetry = 10
                    //             },
                    //             acceptText: 'Yes',
                    //             cancelText: 'No'
                    //         });
                    //         return;
                    //     }
                    //     this.addItem()
                    // })
                }
                else {
                    this.detailsCount++
                    this.data.transport_order_details.push({
                        line_id: this.detailsCount,
                        warehouse_id: this.$store.state.user.userconfig.warehouse_id,
                        product_id: null,
                        description: '',
                        pack_id: '',
                        batch: '',
                        expired_date: null,
                        qty: '',
                        uom_id: null,
                        stock_type_id: this.$store.state.user.userconfig.stock_type_id,
                        committed_qty: 0,
                        base_qty: '',
                        base_uom_id: null,
                        uomOptions: [],
                        defaultUom: [],
                        qtyError: false,
                        denominator: 0,
                        numerator: 0,
                    })
                    
                    this.assignLineId()
                }
            },
            getProduct(detail) {
                this.isLoading = true
                this.maxRetry--
                detail.uom_id = null
                this.$http.get('master/product/'+detail.product_id)
                .then(res => {
                    detail.uomOptions = [] 
                    res.data.uoms.map(item => {
                        detail.uomOptions.push({
                            value: item.uom.id,
                            text: item.uom.name,
                            numerator: item.numerator,
                            denominator: item.denominator
                        })
                    })

                    detail.defaultUom = []
                    detail.defaultUom.push({
                        value: res.data.default_uom.uom.id,
                        text: res.data.default_uom.uom.name
                    })

                    detail.description = res.data.product.description_1
                    detail.base_uom_id = res.data.default_uom.uom_id
                    detail.uom_id = res.data.default_uom.uom_id

                    this.uomChange(detail)

                    this.isLoading = false
                })
                // .catch(() => {
                //     if(this.maxRetry <= 0){
                //         this.isLoading = false
                //         this.$vs.dialog({
                //             type: 'confirm',
                //             color: 'danger',
                //             title: 'Server Error',
                //             text: 'Try again?',
                //             accept: () => {
                //                 this.getProduct(detail)
                //                 this.maxRetry = 10
                //             },
                //             acceptText: 'Yes',
                //             cancelText: 'No'
                //         });
                //         return;
                //     }
                //     this.getProduct(detail)
                // })
            },
            uomChange(detail) {
                detail.uomOptions.map(uom => {
                    if(uom.value == detail.uom_id) {
                        detail.denominator = uom.denominator
                        detail.numerator = uom.numerator
                    }
                })
            },
            convertQty(detail){
                detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
            },
            validateQty(detail) {
                if(detail.qty <= 0) {
                    detail.qtyError = true
                }
                else {
                    detail.qtyError = false
                }
            },
            setOrigin() {
                this.fetchData('master/customers/' + this.data.transport_order.origin.id)
                .then(res => {
                    this.data.transport_order.origin_1 = res.data.address_1
                    this.data.transport_order.origin_2 = res.data.address_2
                })
            },
            setDestination() {
                this.fetchData('master/customers/' + this.data.transport_order.destination.id)
                .then(res => {
                    this.data.transport_order.destination_1 = res.data.address_1
                    this.data.transport_order.destination_2 = res.data.address_2
                })
            },
            clientChange() {
                this.productOptions = []
                if(this.data.transport_order_details.length > 0) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Confirmation',
                        text: 'Changing client will remove details, continue?',
                        accept: () => {
                            this.data.transport_order_details = []
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                }
            },
            assignLineId() {
                this.data.transport_order_details.map((detail, index) => {
                    detail.line_id = index + 1
                })
            },
            combineLine() {
                const details = []

                this.data.transport_order_details.map(item => {
                    if(details.length >= 1) {
                        details.map(detail => {
                            if(detail.product_id == item.product_id && detail.stock_type_id == item.stock_type_id && detail.uom_id == item.uom_id && detail.pack_id == item.pack_id && detail.expired_date == item.expired_date && detail.batch == item.batch) {
                                detail.qty = parseInt(detail.qty) + parseInt(item.qty)
                            }
                            else {
                                details.push(item)
                            }
                        })
                    }
                    else {
                        details.push(item)
                    }
                })

                return details
            }
        },
        mounted(){
            // console.log(this.$route.params.dataReference)
            // alert(JSON.stringify( this.$route.params.dataReference.transport_order_details))
            this.fetchAllData()
            if(this.$route.params.withReference){
                this.$http.all([this.$http.post('master/warehouses'), this.$http.post('master/product/showbyclient',{ client_code: this.data.transport_order.client.client_code }), this.$http.post('master/stocktypes')])
                    .then(this.$http.spread((warehouses, products, stocktypes) => {
                        if(this.warehouseOptions.length == 0){
                            warehouses.data.data.map(item => {
                                this.warehouseOptions.push({
                                    value: item.id,
                                    text: item.name
                                })
                            })
                        }
    
                        if(this.productOptions.length == 0){
                            products.data.data.map(item => {
                                this.productOptions.push({
                                    value: item.id,
                                    text: item.product_code,
                                })
                            })
                        }
    
                        if(this.stockTypeOptions.length == 0){
                            stocktypes.data.data.map(item => {
                                this.stockTypeOptions.push({
                                    value: item.id,
                                    text: item.name,
                                })
                            })
                        }
    
                        this.data.transport_order = this.$route.params.dataReference.transport_order
                        this.data.transport_order.outbound_reference = this.$route.params.dataReference.transport_order.outbound.outbound_reference
                        
                        this.$route.params.dataReference.transport_order_details.map((item)=>{
                            this.data.transport_order_details.push(item)
                            this.getProduct(item)
                        })

                        this.withRef = this.$route.params.withReference
                        setTimeout(() => {
                            this.isLoading = false
                        }, 500)
    
                        // this.assignLineId()
                    }))
                    .catch((error) => {
                        console.log(error)
                    })

            }
        },
    }
</script>